import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import LoginPage from '../pages/login/login'
import AdminHome from '../pages/admin/home'
import ErrorBoundary from '../error/index'
const BasicRoute = (): JSX.Element => (
    <ErrorBoundary>
        <BrowserRouter basename={'/webapp'}>
            <Switch>
                <Route path="/login" component={LoginPage} />
                <Route path="/admin">
                    <AdminHome />
                </Route>
                <Route path="*">
                    <AdminHome />
                </Route>
            </Switch>
        </BrowserRouter>
    </ErrorBoundary>
)
export default BasicRoute
